import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class BrokerUsersAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_BROKERS')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_BROKERS')));

    return this.api;
  }

  async getUsers() {
    return this.getAPI().getInstance().get('/users');
  }

  async postUser(data) {
    return this.getAPI().getInstance().post('/users/save', data);
  }

  async putUserActiveness(status, idUserManager) {
    return this.getAPI().getInstance().put(`/users/${idUserManager}/active`, { active: status });
  }
}

const api = new BrokerUsersAPI();
export default api;
